import { Component, Inject, OnInit } from '@angular/core';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import { environment } from '@environments/environment';

@Component({
    selector: 'app-dialog-confirm-download',
    templateUrl: './dialog-confirm-download.component.html',
    styles: [],
    standalone: false
})
export class DialogConfirmDownloadComponent implements OnInit {
  public isMobile: boolean;
  constructor(
    public dialogRef: MatDialogRef<DialogConfirmDownloadComponent>,
    @Inject(MAT_DIALOG_DATA) public data
    ) {
      this.isMobile = environment.platform === 'mobile';
    }

  ngOnInit() { }
}

